/* NEXT GEN qualified ViewContent v1. Measures only this landing, in its top document. */
(() => {
  'use strict';
  const EVENT = 'wimpire_next_gen_qualified_view';
  const KEY = '__wimpireNextGenQualifiedViewContentV1';
  if (!/(?:^|\/)pages\/next-gen-narrow-w\/?$/.test(location.pathname)) return;
  if (window[KEY]) return;

  const randomId = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  };
  const pageId = randomId();
  const state = window[KEY] = {
    page_load_id: pageId,
    event_id: 'ngvc-' + pageId,
    visible_ms: 0,
    trigger_reason: null,
    published: false
  };
  let activeSince = document.visibilityState === 'visible' ? performance.now() : null;
  let suspended = false;
  let timer = null;
  let observer = null;
  let observedTarget = null;
  let featureLoading = false;
  let lastFeatureAttempt = -Infinity;
  const isVisible = () => !suspended && document.visibilityState === 'visible';

  function accountTime() {
    const now = performance.now();
    if (activeSince !== null) state.visible_ms += Math.max(0, now - activeSince);
    activeSince = isVisible() ? now : null;
  }
  function privacyAllowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      // Match the existing custom pixel's MARKETING + SALE_OF_DATA requirements.
      return !!privacy && privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) {
      return false;
    }
  }
  function ensurePrivacyApi() {
    const shopify = window.Shopify;
    if (!shopify || shopify.customerPrivacy || typeof shopify.loadFeatures !== 'function') return;
    if (featureLoading || performance.now() - lastFeatureAttempt < 5000) return;
    featureLoading = true;
    lastFeatureAttempt = performance.now();
    try {
      shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => {
        featureLoading = false;
        evaluate();
      });
    } catch (_) {
      featureLoading = false;
    }
  }
  function targetVisible(target) {
    if (!target || !target.isConnected || !isVisible()) return false;
    const style = getComputedStyle(target);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    const rect = target.getBoundingClientRect();
    const width = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
    const height = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    return rect.width > 0 && rect.height > 0 && width >= 1 && height >= 1;
  }
  function stopQualificationObservers() {
    if (observer) observer.disconnect();
    window.removeEventListener('scroll', evaluate);
    window.removeEventListener('resize', evaluate);
  }
  function cleanup() {
    clearTimeout(timer);
    timer = null;
    stopQualificationObservers();
    document.removeEventListener('visibilitychange', onVisibilityChange);
    document.removeEventListener('visitorConsentCollected', onConsentChange);
    window.removeEventListener('pagehide', onPageHide);
    window.removeEventListener('pageshow', onPageShow);
  }
  function schedule() {
    clearTimeout(timer);
    timer = null;
    if (state.published || !isVisible()) return;
    const remaining = Math.max(1, 10000 - state.visible_ms);
    timer = setTimeout(evaluate, state.trigger_reason ? 500 : Math.min(250, remaining));
  }
  function evaluate() {
    if (state.published) return;
    accountTime();
    if (!state.trigger_reason) {
      const target = document.getElementById('next-gen-buy');
      if (observer && target && target !== observedTarget) {
        observedTarget = target;
        observer.observe(target);
      }
      if (state.visible_ms >= 10000) state.trigger_reason = 'time_10s';
      else if (targetVisible(target)) state.trigger_reason = 'variant_section';
      if (state.trigger_reason) stopQualificationObservers();
    }
    if (state.trigger_reason && isVisible()) {
      ensurePrivacyApi();
      const analytics = window.Shopify && window.Shopify.analytics;
      if (privacyAllowed() && analytics && typeof analytics.publish === 'function') {
        // Set the lock before publishing: a synchronous/reentrant callback cannot publish twice.
        state.published = true;
        try {
          const accepted = analytics.publish(EVENT, {
            content_name: 'NEXT GEN Narrow W',
            landing_id: 'next_gen_narrow_w',
            trigger_reason: state.trigger_reason,
            page_load_id: state.page_load_id,
            event_id: state.event_id
          });
          if (accepted === false) state.published = false;
        } catch (_) {
          state.published = false;
        }
        if (state.published) {
          cleanup();
          return;
        }
      }
    }
    schedule();
  }
  function onVisibilityChange() {
    accountTime();
    evaluate();
  }
  function onConsentChange() {
    // Wait for Shopify's own current permission state, rather than trust event.detail.
    evaluate();
  }
  function onPageHide() {
    accountTime();
    suspended = true;
    activeSince = null;
    clearTimeout(timer);
    timer = null;
  }
  function onPageShow() {
    if (!suspended || state.published) return;
    suspended = false;
    activeSince = isVisible() ? performance.now() : null;
    evaluate();
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(() => evaluate(), {root: null, rootMargin: '0px', threshold: 0});
  }
  document.addEventListener('visibilitychange', onVisibilityChange);
  document.addEventListener('visitorConsentCollected', onConsentChange);
  window.addEventListener('pagehide', onPageHide);
  window.addEventListener('pageshow', onPageShow);
  window.addEventListener('scroll', evaluate, {passive: true});
  window.addEventListener('resize', evaluate, {passive: true});
  ensurePrivacyApi();
  evaluate();
})();
